// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import HomeSite from '@/components/HomeSite.vue'
import datenSchutz from '@/components/datenSchutz.vue'
import impressumSite from '@/components/impressumSite.vue'

const routes = [
    { path: '/', name: 'Home', component: HomeSite },
    { path: '/datenschutz', name: 'Datenschutz', component: datenSchutz },
    { path: '/impressum', name: 'Impressum', component: impressumSite },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

export default router